import React from "react";
import FusionAuthService from "../../services/fusionAuthService";

export default function Logout() {
  const logoutUrl: string | null = FusionAuthService.logout();
  logoutUrl && window.location.assign(logoutUrl);

  return <h2>Goodbye!</h2>;
}
